var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgValidatingTicket(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2633_7600)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40 26.0616V4.78801C39.9985 3.51542 39.4923 2.29538 38.5925 1.39553C37.6926 0.495678 36.4726 -0.0105113 35.2 -0.0119934H4.8C3.52832 -0.00756574 2.31 0.499569 1.41078 1.39879C0.511562 2.298 0.00442766 3.51633 0 4.78801L0 17.588C0 18.0124 0.168571 18.4193 0.468629 18.7194C0.768687 19.0194 1.17565 19.188 1.6 19.188H8V40.288C7.99917 40.574 8.07532 40.855 8.22047 41.1014C8.36562 41.3478 8.57441 41.5507 8.82494 41.6886C9.07548 41.8266 9.35852 41.8945 9.64437 41.8854C9.93023 41.8763 10.2084 41.7904 10.4496 41.6368L12.6048 40.284L15.5592 42.1496C15.8144 42.3081 16.1088 42.3921 16.4092 42.3921C16.7096 42.3921 17.004 42.3081 17.2592 42.1496L20.2128 40.2856L23.1464 42.14C23.4018 42.3039 23.6989 42.3911 24.0024 42.3911C24.3059 42.3911 24.603 42.3039 24.8584 42.14L26.4728 41.12C27.2021 42.8627 28.3604 44.3925 29.8398 45.5672C31.3192 46.742 33.0718 47.5234 34.9344 47.8388C36.7969 48.1543 38.7091 47.9935 40.4928 47.3713C42.2765 46.7492 43.8739 45.6861 45.1363 44.2807C46.3988 42.8754 47.2852 41.1736 47.7132 39.3336C48.1412 37.4936 48.0969 35.5752 47.5843 33.757C47.0717 31.9388 46.1075 30.2798 44.7815 28.9343C43.4554 27.5888 41.8106 26.6006 40 26.0616ZM8 17.5896H1.6V4.78961C1.6038 3.9407 1.94326 3.12776 2.54428 2.52824C3.14531 1.92872 3.95909 1.59129 4.808 1.58961H4.8712C4.95427 1.58767 5.03738 1.59115 5.12 1.60001C5.92903 1.70836 6.66983 2.1108 7.20104 2.73055C7.73225 3.35029 8.01666 4.14393 8 4.96001V17.5896ZM24 40.7896L21.0664 38.9344C20.8107 38.7708 20.5135 38.6838 20.21 38.6838C19.9065 38.6838 19.6093 38.7708 19.3536 38.9344L16.4088 40.7984L13.4584 38.936C13.2032 38.7719 12.9062 38.6846 12.6028 38.6846C12.2994 38.6846 12.0024 38.7719 11.7472 38.936L9.6 40.288V4.96001C9.59877 3.71849 9.14351 2.52029 8.32 1.59121H35.2C36.0487 1.59121 36.8626 1.92835 37.4627 2.52847C38.0629 3.12858 38.4 3.94251 38.4 4.79121V25.7176C36.5764 25.4448 34.7136 25.6285 32.9784 26.2521C31.2432 26.8758 29.6897 27.92 28.457 29.2914C27.2243 30.6627 26.3509 32.3182 25.915 34.1099C25.4791 35.9015 25.4943 37.7733 25.9592 39.5576L24 40.7896ZM36.8 46.392C34.9013 46.392 33.0452 45.829 31.4665 44.7741C29.8878 43.7193 28.6574 42.2199 27.9308 40.4658C27.2042 38.7116 27.014 36.7814 27.3845 34.9191C27.7549 33.0569 28.6692 31.3464 30.0118 30.0038C31.3544 28.6612 33.0649 27.7469 34.9271 27.3765C36.7894 27.0061 38.7196 27.1962 40.4738 27.9228C42.2279 28.6494 43.7272 29.8798 44.7821 31.4585C45.837 33.0372 46.4 34.8933 46.4 36.792C46.397 39.3372 45.3847 41.7773 43.585 43.577C41.7852 45.3767 39.3452 46.389 36.8 46.392Z",
    fill: "url(#paint0_linear_2633_7600)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.8 17.5896H35.2C35.4122 17.5896 35.6157 17.5053 35.7657 17.3553C35.9157 17.2053 36 17.0018 36 16.7896C36 16.5774 35.9157 16.3739 35.7657 16.2239C35.6157 16.0739 35.4122 15.9896 35.2 15.9896H12.8C12.5878 15.9896 12.3843 16.0739 12.2343 16.2239C12.0843 16.3739 12 16.5774 12 16.7896C12 17.0018 12.0843 17.2053 12.2343 17.3553C12.3843 17.5053 12.5878 17.5896 12.8 17.5896Z",
    fill: "url(#paint1_linear_2633_7600)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24 31.9904H12.8C12.5878 31.9904 12.3843 32.0747 12.2343 32.2247C12.0843 32.3747 12 32.5782 12 32.7904C12 33.0026 12.0843 33.206 12.2343 33.3561C12.3843 33.5061 12.5878 33.5904 12.8 33.5904H24C24.2122 33.5904 24.4157 33.5061 24.5657 33.3561C24.7157 33.206 24.8 33.0026 24.8 32.7904C24.8 32.5782 24.7157 32.3747 24.5657 32.2247C24.4157 32.0747 24.2122 31.9904 24 31.9904Z",
    fill: "url(#paint2_linear_2633_7600)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.8 21.5896H15.2C15.4122 21.5896 15.6157 21.5053 15.7657 21.3553C15.9157 21.2053 16 21.0018 16 20.7896C16 20.5774 15.9157 20.3739 15.7657 20.2239C15.6157 20.0739 15.4122 19.9896 15.2 19.9896H12.8C12.5878 19.9896 12.3843 20.0739 12.2343 20.2239C12.0843 20.3739 12 20.5774 12 20.7896C12 21.0018 12.0843 21.2053 12.2343 21.3553C12.3843 21.5053 12.5878 21.5896 12.8 21.5896Z",
    fill: "url(#paint3_linear_2633_7600)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32 19.9896H18.4C18.1878 19.9896 17.9843 20.0739 17.8343 20.2239C17.6843 20.3739 17.6 20.5774 17.6 20.7896C17.6 21.0018 17.6843 21.2053 17.8343 21.3553C17.9843 21.5053 18.1878 21.5896 18.4 21.5896H32C32.2122 21.5896 32.4157 21.5053 32.5657 21.3553C32.7157 21.2053 32.8 21.0018 32.8 20.7896C32.8 20.5774 32.7157 20.3739 32.5657 20.2239C32.4157 20.0739 32.2122 19.9896 32 19.9896Z",
    fill: "url(#paint4_linear_2633_7600)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.8 25.5904H15.2C15.4122 25.5904 15.6157 25.5061 15.7657 25.3561C15.9157 25.2061 16 25.0026 16 24.7904C16 24.5782 15.9157 24.3748 15.7657 24.2247C15.6157 24.0747 15.4122 23.9904 15.2 23.9904H12.8C12.5878 23.9904 12.3843 24.0747 12.2343 24.2247C12.0843 24.3748 12 24.5782 12 24.7904C12 25.0026 12.0843 25.2061 12.2343 25.3561C12.3843 25.5061 12.5878 25.5904 12.8 25.5904Z",
    fill: "url(#paint5_linear_2633_7600)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.2 23.9896H18.4C18.1878 23.9896 17.9843 24.0739 17.8343 24.2239C17.6843 24.3739 17.6 24.5774 17.6 24.7896C17.6 25.0018 17.6843 25.2053 17.8343 25.3553C17.9843 25.5053 18.1878 25.5896 18.4 25.5896H31.2C31.4122 25.5896 31.6157 25.5053 31.7657 25.3553C31.9157 25.2053 32 25.0018 32 24.7896C32 24.5774 31.9157 24.3739 31.7657 24.2239C31.6157 24.0739 31.4122 23.9896 31.2 23.9896Z",
    fill: "url(#paint6_linear_2633_7600)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.8 29.5904H15.2C15.4122 29.5904 15.6157 29.5061 15.7657 29.3561C15.9157 29.206 16 29.0026 16 28.7904C16 28.5782 15.9157 28.3747 15.7657 28.2247C15.6157 28.0747 15.4122 27.9904 15.2 27.9904H12.8C12.5878 27.9904 12.3843 28.0747 12.2343 28.2247C12.0843 28.3747 12 28.5782 12 28.7904C12 29.0026 12.0843 29.206 12.2343 29.3561C12.3843 29.5061 12.5878 29.5904 12.8 29.5904Z",
    fill: "url(#paint7_linear_2633_7600)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.4 27.9904H18.4C18.1878 27.9904 17.9843 28.0747 17.8343 28.2247C17.6843 28.3747 17.6 28.5782 17.6 28.7904C17.6 29.0026 17.6843 29.206 17.8343 29.3561C17.9843 29.5061 18.1878 29.5904 18.4 29.5904H26.4C26.6122 29.5904 26.8157 29.5061 26.9657 29.3561C27.1157 29.206 27.2 29.0026 27.2 28.7904C27.2 28.5782 27.1157 28.3747 26.9657 28.2247C26.8157 28.0747 26.6122 27.9904 26.4 27.9904Z",
    fill: "url(#paint8_linear_2633_7600)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.2 9.58801C15.3404 9.58814 15.4783 9.62523 15.5998 9.69553C15.7213 9.76583 15.8222 9.86687 15.8923 9.98851C15.9624 10.1102 15.9993 10.2481 15.9992 10.3885C15.9991 10.5289 15.9621 10.6668 15.8918 10.7883C15.8216 10.9099 15.7206 11.0108 15.599 11.081C15.4774 11.1511 15.3394 11.188 15.199 11.188C15.0586 11.188 14.9207 11.151 14.7991 11.0808C14.6776 11.0106 14.5766 10.9096 14.5064 10.788C14.4557 10.6937 14.3865 10.6106 14.303 10.5435C14.2195 10.4764 14.1234 10.4268 14.0204 10.3975C13.9174 10.3683 13.8096 10.36 13.7033 10.3732C13.597 10.3864 13.4945 10.4208 13.4017 10.4744C13.309 10.528 13.228 10.5996 13.1635 10.6851C13.0989 10.7705 13.0522 10.8681 13.0261 10.9719C13 11.0758 12.995 11.1838 13.0114 11.2897C13.0278 11.3955 13.0653 11.4969 13.1216 11.588C13.4116 12.0753 13.8652 12.4439 14.4016 12.628V12.788C14.4016 13.0002 14.4859 13.2037 14.6359 13.3537C14.7859 13.5037 14.9894 13.588 15.2016 13.588C15.4138 13.588 15.6173 13.5037 15.7673 13.3537C15.9173 13.2037 16.0016 13.0002 16.0016 12.788V12.64C16.5355 12.4526 16.9858 12.0821 17.2726 11.5943C17.5593 11.1064 17.6641 10.5328 17.5682 9.97513C17.4723 9.41744 17.1821 8.91173 16.7488 8.54769C16.3156 8.18364 15.7675 7.98479 15.2016 7.98641C15.0612 7.98627 14.9233 7.94919 14.8018 7.87889C14.6803 7.80858 14.5794 7.70754 14.5093 7.5859C14.4392 7.46426 14.4023 7.32632 14.4024 7.18592C14.4025 7.04552 14.4395 6.90762 14.5098 6.78607C14.58 6.66452 14.681 6.56359 14.8026 6.49344C14.9242 6.42329 15.0622 6.38637 15.2026 6.38641C15.343 6.38644 15.4809 6.42342 15.6025 6.49364C15.724 6.56385 15.825 6.66482 15.8952 6.78641C16.0046 6.96329 16.1786 7.0906 16.3804 7.14134C16.5821 7.19208 16.7956 7.16227 16.9757 7.05823C17.1558 6.95418 17.2883 6.78408 17.3451 6.584C17.4019 6.38391 17.3786 6.16956 17.28 5.98641C16.9904 5.4982 16.5367 5.12876 16 4.94401V4.78801C16 4.57583 15.9157 4.37235 15.7657 4.22232C15.6157 4.07229 15.4122 3.98801 15.2 3.98801C14.9878 3.98801 14.7843 4.07229 14.6343 4.22232C14.4843 4.37235 14.4 4.57583 14.4 4.78801V4.93521C13.8667 5.12306 13.417 5.49362 13.1307 5.98123C12.8444 6.46885 12.7399 7.04206 12.8357 7.59935C12.9315 8.15663 13.2215 8.66202 13.6542 9.02601C14.0869 9.38999 14.6345 9.58908 15.2 9.58801Z",
    fill: "url(#paint9_linear_2633_7600)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.8 9.58801H28C28.2122 9.58801 28.4157 9.50372 28.5657 9.35369C28.7157 9.20366 28.8 9.00018 28.8 8.78801C28.8 8.57583 28.7157 8.37235 28.5657 8.22232C28.4157 8.07229 28.2122 7.98801 28 7.98801H20.8C20.5878 7.98801 20.3843 8.07229 20.2343 8.22232C20.0843 8.37235 20 8.57583 20 8.78801C20 9.00018 20.0843 9.20366 20.2343 9.35369C20.3843 9.50372 20.5878 9.58801 20.8 9.58801Z",
    fill: "url(#paint10_linear_2633_7600)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.8 13.5888H35.2C35.4122 13.5888 35.6157 13.5045 35.7657 13.3545C35.9157 13.2045 36 13.001 36 12.7888C36 12.5766 35.9157 12.3731 35.7657 12.2231C35.6157 12.0731 35.4122 11.9888 35.2 11.9888H20.8C20.5878 11.9888 20.3843 12.0731 20.2343 12.2231C20.0843 12.3731 20 12.5766 20 12.7888C20 13.001 20.0843 13.2045 20.2343 13.3545C20.3843 13.5045 20.5878 13.5888 20.8 13.5888Z",
    fill: "url(#paint11_linear_2633_7600)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.1448 32.332L35.0912 39.552L33.3656 37.8256C33.2152 37.6756 33.0113 37.5915 32.7989 37.5918C32.5864 37.5921 32.3828 37.6768 32.2328 37.8272C32.0828 37.9776 31.9987 38.1815 31.999 38.3939C31.9993 38.6064 32.084 38.81 32.2344 38.96L34.6344 41.36C34.7848 41.5092 34.9882 41.5926 35.2 41.592C35.2232 41.5932 35.2464 41.5932 35.2696 41.592C35.386 41.5818 35.4988 41.5462 35.5999 41.4877C35.7011 41.4293 35.7882 41.3494 35.8552 41.2536L41.4552 33.2536C41.5178 33.1677 41.5626 33.0701 41.587 32.9667C41.6114 32.8632 41.615 32.756 41.5975 32.6511C41.58 32.5463 41.5418 32.446 41.4851 32.3561C41.4284 32.2662 41.3544 32.1884 41.2673 32.1275C41.1802 32.0665 41.0819 32.0235 40.978 32.001C40.8741 31.9784 40.7668 31.9768 40.6623 31.9962C40.5578 32.0157 40.4582 32.0557 40.3694 32.114C40.2805 32.1724 40.2042 32.2478 40.1448 32.336V32.332Z",
    fill: "url(#paint12_linear_2633_7600)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2633_7600",
    x1: 41.8288,
    y1: 63.8915,
    x2: -16.0857,
    y2: 41.3906,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8731E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4885ED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2633_7600",
    x1: 32.9124,
    y1: 18.1194,
    x2: 31.9594,
    y2: 12.565,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8731E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4885ED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2633_7600",
    x1: 23.1533,
    y1: 34.1201,
    x2: 21.4863,
    y2: 28.9385,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8731E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4885ED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2633_7600",
    x1: 15.4854,
    y1: 22.1194,
    x2: 12.6277,
    y2: 19.3434,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8731E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4885ED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2633_7600",
    x1: 30.8446,
    y1: 22.1194,
    x2: 29.4014,
    y2: 16.7924,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8731E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4885ED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2633_7600",
    x1: 15.4854,
    y1: 26.1202,
    x2: 12.6277,
    y2: 23.3443,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8731E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4885ED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_2633_7600",
    x1: 30.1475,
    y1: 26.1194,
    x2: 28.636,
    y2: 20.8337,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8731E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4885ED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_2633_7600",
    x1: 15.4854,
    y1: 30.1201,
    x2: 12.6277,
    y2: 27.3442,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8731E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4885ED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_2633_7600",
    x1: 25.965,
    y1: 30.1201,
    x2: 23.8935,
    y2: 25.2908,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8731E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4885ED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_2633_7600",
    x1: 16.9851,
    y1: 16.7666,
    x2: 10.5603,
    y2: 15.5179,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8731E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4885ED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_2633_7600",
    x1: 27.6679,
    y1: 10.1178,
    x2: 25.4729,
    y2: 5.42701,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8731E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4885ED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_2633_7600",
    x1: 33.9416,
    y1: 14.1186,
    x2: 32.5614,
    y2: 8.75588,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8731E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4885ED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_2633_7600",
    x1: 40.3722,
    y1: 44.7748,
    x2: 28.779,
    y2: 40.2706,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8731E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4885ED"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2633_7600"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgValidatingTicket);
export default __webpack_public_path__ + "static/media/validating-ticket.a98433fbfea788bc054ecda4331a3e53.svg";
export { ForwardRef as ReactComponent };